<template>
  <PartnerListWidget :href="ctaLink" @click="onLinkClick">
    <template #icon>
      <HgIcon icon="Map" size="large" theme="secondary" />
    </template>
    <template #content>
      <span>
        {{ t('integrations.ilocator.message') }}
        <span :class="$style.cta">{{ ctaAction }}</span>
      </span>
    </template>
  </PartnerListWidget>
</template>

<script lang="ts" setup>
import { HgIcon } from '@smg-real-estate/domus';
import { computed } from 'vue';

import PartnerListWidget from '@/components/PartnerIntegrations/PartnerListWidget/PartnerListWidget.vue';
import { InteractionGoal } from '@/helpers/GTM/GTMParameters';
import { useI18n } from 'vue-i18n';

defineOptions({
  name: 'ILocator',
});

const { t } = useI18n();

const emit = defineEmits<{
  trackPartnerLink: [ctaLink: string, goal: InteractionGoal];
}>();

const ctaLink = computed((): string => {
  return t('integrations.ilocator.href');
});

const ctaAction = computed((): string => {
  return t('integrations.ilocator.action');
});

const onLinkClick = (): void => {
  emit('trackPartnerLink', ctaLink.value, InteractionGoal.COMPARE_LIVING_COSTS);
};
</script>
<style lang="scss" module>
@import '@/assets/variables';

.cta {
  color: var(--base-color-link);

  @include font-bold;
}
</style>
